<div class="wgu-container">
  <h2>Reset Your Password</h2>



  <div class="h1">Step 2: Answer Security Questions</div>

  <p class="mb-6">
    Please enter the answers to the following questions. These must match
    the answers you provided previously.
</p>

  <form
    [formGroup]="form"
    (ngSubmit)="submitAnswersStep1(form.value)"
    autocomplete="off"
    novalidate
  >
    <div class="w-full">
        


        <div *ngFor="let item of questions; let i = index">
          <p>{{ item.question }}</p>

          <div class="form-group">
            <label class="wgu-outlined general-questions default-p ">
              <input
                formControlName="answerFormControl{{ i }}"
                type="text"
                class="form-control"
                placeholder="Answer"
                (blur)="saveAnswer()"
              />
            </label>
          </div>

          <div class="my-3"></div>
        </div>
    </div>

    <div class="form-actions">
      <button class="wgu-btn" type="submit" [disabled]="!disabledFlag">
        Next
      </button>
      <a href="identityiq/external/cancelPage" class="wgu-btn-text">
        Cancel
      </a>
    </div>
  </form>
</div>